import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-021274c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "product__content" }
const _hoisted_3 = { class: "product__title" }
const _hoisted_4 = { class: "product__price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "product",
    to: `/product/${_ctx.product.id}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: "product__image",
        src: _ctx.product.thumbnail,
        alt: ""
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.product.title), 1),
        _createElementVNode("span", _hoisted_4, "$" + _toDisplayString(_ctx.product.price), 1)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}